import SpriteSymbol from "../../../node_modules/_svg-baker-runtime@1.4.7@svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/_svg-sprite-loader@4.3.0@svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-rzline-description",
  "use": "icon-rzline-description-usage",
  "viewBox": "0 0 19 19",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 19 19\" id=\"icon-rzline-description\">\n  <defs>\n    <style>\n      #icon-rzline-description .cls-1 {\n        fill-rule: evenodd;\n      }\n    </style>\n  </defs>\n  <path id=\"icon-rzline-description_description\" class=\"cls-1\" d=\"M2318,981h19v1h-19v-1Zm18-18h1v19h-1V963Zm-18,0h1v19h-1V963Zm0,0h19v1h-19v-1Zm4,12h6v1h-6v-1Zm0-4h11v1h-11v-1Zm0-4h11v1h-11v-1Z\" transform=\"translate(-2318 -963)\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/rzline-description.svg
// module id = /LzY
// module chunks = 70